import { Deprecation } from 'deprecation';
import xss from 'xss';
const KEYCODE_ENTER = 13;
const KEYCODE_SPACE = 32;
export const deprecateImageField = ({ oldProp, newProp, smallValue, mediumValue, largeValue, }) => {
    if (process.env.NODE_ENV !== 'production') {
        console.warn(new Deprecation(`"${oldProp}" field is deprecated, please use "${newProp}" instead: https://sites.spotify.net/spa/%40spotify-internal-landing-page-library/?path=/docs/benefits--basic-benefits#v750`));
    }
    const migratedObject = {
        small: { '1x': smallValue },
    };
    if (mediumValue)
        migratedObject.medium = { '1x': mediumValue };
    if (largeValue)
        migratedObject.large = { '1x': largeValue };
    return migratedObject;
};
export const handleKeyUp = ({ e, callback, }) => {
    if (e.keyCode === KEYCODE_ENTER || e.keyCode === KEYCODE_SPACE) {
        e.preventDefault();
        callback();
    }
};
export const purify = (input) => {
    const options = {
        whiteList: {
            a: ['class', 'style', 'href'],
            b: [],
            br: [],
            div: ['class', 'style'],
            em: [],
            i: [],
            li: [],
            ol: [],
            p: [],
            span: ['class', 'style'],
            strong: [],
            sup: [],
            ul: [],
        },
    };
    return typeof input !== 'string' ? '' : xss(input, options);
};
export const isArabicMarket = (market, direction) => {
    return (market === null || market === void 0 ? void 0 : market.includes('-ar')) && direction === 'rtl';
};
//# sourceMappingURL=helpers.js.map